import React,{ Component } from 'react';
import NavLink             from '../generic/nav-link';
import { Link }            from 'react-router'
import Parse               from 'parse';

let logoSrc = require('../../../img/wl-logo-black.png');

export default class UserNavbar  extends Component {

    constructor(props){
        super(props);
    }

    render(){
        return (
            <nav className="navbar navbar-static-top">
              <div className="container-fluid" style={{marginLeft:60,marginRight:60}}>
                <div className="navbar-header">
                  <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                  <a className="navbar-brand" href="/">
                      <img style = {{width:110}} src={logoSrc} />
                  </a>
                </div>
                <div id="navbar" className="collapse navbar-collapse">
                    <ul className="nav navbar-nav navbar-right">
                      <li className="dropdown">
                          <a href="#" className="dropdown-toggle register-nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" style={{color:'black'}}>
                              {Parse.User.current().get('name')}
                          </a>
                        <ul className="dropdown-menu">
                          <li className="dropdown-header">User Account</li>
                          <li><Link to="/logout">Log out</Link></li>
                        </ul>
                      </li>
                    </ul>
                </div>{/*<!--/.nav-collapse -->*/}
               </div>
           </nav>
        )
    }
}



// WEBPACK FOOTER //
// src/components/layout/user-navbar.js